export const pages = {
  service: {
    type: 'SERVICE_PAGE',
    step: 1,
  },

  city: {
    type: 'CITY_PAGE',
    step: 2,
  },

  age: {
    type: 'AGE_PAGE',
    step: 3,
  },

  contactSingleService: {
    type: 'CONTACT_FORM_PAGE_SINGLE_SERVICE',
    step: 5,
  },

  contact: {
    type: 'CONTACT_FORM_PAGE',
    step: 5,
  },

  contactWithAddress: {
    type: 'CONTACT_FROM_WITH_ADDRESS_PAGE',
    step: 5,
  },

  map: {
    type: 'MAP_PAGE',
    step: 4,
    // infoBarTexts: [
    //   {
    //     text: "Testujemy nowy proces zapisów - zgłoś sugestie pod 668 115 750",
    //     color: "#FFFFFF",
    //     bgColor: "var(--color-main-orange)",
    //   },
    //   {
    //     text: "Przetestuj Nas! Za pierwszą lekcję nie płacisz, gdy dziecko nie kontynuuje zajęć.",
    //     color: "#fff",
    //     bgColor: "var(--color-blue-slider)",
    //   },
    // ],
  },

  // used to wait untill post request gets delivered
  thankYou: {
    type: 'THANK_YOU_PAGE',
    step: null,
  },
} as const;
